// src/pages/SuperAdminPlaceholder.jsx

import React from 'react';
import { Sparkles } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card.jsx';

export default function SuperAdminPlaceholder({ title, description }) {
  return (
    <Card>
      <CardContent className="p-10">
        <div className="flex flex-col items-center justify-center text-center max-w-md mx-auto">
          <div className="h-12 w-12 rounded-full bg-[#1a1a1a] border border-[#2a2a2a] flex items-center justify-center mb-4">
            <Sparkles className="h-6 w-6 text-[#a0a0a0]" />
          </div>
          <h2 className="text-xl font-semibold text-white">{title}</h2>
          <p className="text-sm text-[#a0a0a0] mt-2">{description}</p>
        </div>
      </CardContent>
    </Card>
  );
}